import { type ComponentPropsWithoutRef, forwardRef } from "react";

import { Button } from "@src/shared/components/ui/button";
import { cn } from "@src/shared/lib/utils";

export interface UploadHistoryFileNameTriggerProps
  extends ComponentPropsWithoutRef<typeof Button> {
  fileName: string;
}

export const UploadHistoryFileNameTrigger = forwardRef<
  HTMLButtonElement,
  UploadHistoryFileNameTriggerProps
>(({ className, fileName, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      className={cn(
        "h-auto w-full min-w-0 justify-start rounded-none px-0 py-0 text-left text-[13px] font-medium text-primary shadow-none hover:bg-transparent hover:text-primary",
        className,
      )}
      {...props}
    >
      <span className="block min-w-0 max-w-full truncate">{fileName}</span>
    </Button>
  );
});

UploadHistoryFileNameTrigger.displayName = "UploadHistoryFileNameTrigger";
